module.exports = __webpack_public_path__ + "img/t-shirt.c9c5443f.png";